const metric = (name: string, value: number, numerator: number, denominator: number, extra = {}) => ({
  metric: name,
  value,
  numerator,
  denominator,
  status: 'ok',
  dataQuality: [],
  ...extra,
})

const periods = [ '2026-W31', '2026-W32', '2026-W33', '2026-W34', '2026-W35', '2026-W36' ]
const ppcValues = [ 72, 78, 75, 84, 81, 88 ]
const pcrOneValues = [ 61, 68, 73, 77, 82, 86 ]
const pcrTwoValues = [ 48, 55, 62, 66, 72, 79 ]

export const leanIndicatorsDemoData: any = {
  legacyPpc: {
    weeks: ppcValues.map((value, index) => ({
      number: 31 + index,
      longNumber: 202631 + index,
      percentItems: Math.max(value - 5, 0),
      percentWorks: value,
    })),
  },
  ppc: {
    latestClosed: metric('ppc', 88, 22, 25),
    cumulative: metric('ppc', 79.7, 118, 148),
    series: periods.map((period, index) => ({
      period: { key: period },
      ppc: metric('ppc', ppcValues[index], Math.round(ppcValues[index] / 4), 25),
      movingAverage4: index < 3 ? null : ppcValues.slice(index - 3, index + 1).reduce((sum, value) => sum + value, 0) / 4,
      kept: Math.round(ppcValues[index] / 4),
      notKept: 25 - Math.round(ppcValues[index] / 4),
      withdrawn: index % 3 === 0 ? 1 : 0,
    })),
    breakdowns: {
      performer: [ { key: 'equipo-a', label: 'Equipo estructura' }, { key: 'equipo-b', label: 'Equipo acabados' } ],
      group: [ { key: 'sector-norte', label: 'Sector norte' }, { key: 'sector-sur', label: 'Sector sur' } ],
      taskType: [ { key: 'trabajo', label: 'Trabajo' }, { key: 'tarea', label: 'Tarea' } ],
      location: [ { key: 'nivel-1', label: 'Nivel 1' }, { key: 'nivel-2', label: 'Nivel 2' } ],
    },
  },
  pcr: {
    latest: [ metric('pcr', 86, 24, 28, { horizonWeeks: 1 }), metric('pcr', 79, 22, 28, { horizonWeeks: 2 }) ],
    series: periods.map((period, index) => ({
      period: { key: period },
      horizons: [
        metric('pcr', pcrOneValues[index], Math.round(pcrOneValues[index] * 0.28), 28, { horizonWeeks: 1 }),
        metric('pcr', pcrTwoValues[index], Math.round(pcrTwoValues[index] * 0.28), 28, { horizonWeeks: 2 }),
      ],
    })),
    releaseCompliance: metric('restriction_release_compliance', 76.5, 13, 17),
    restrictionFlow: periods.map((period, index) => ({
      period: { key: period }, identified: [ 9, 7, 11, 6, 5, 8 ][index], closedOnTime: [ 4, 5, 6, 5, 4, 7 ][index], closedLate: [ 2, 1, 3, 1, 1, 1 ][index],
    })),
    aging: [
      { bucket: '0_7', open: 8, overdue: 1 }, { bucket: '8_14', open: 5, overdue: 2 },
      { bucket: '15_30', open: 3, overdue: 2 }, { bucket: 'over_30', open: 2, overdue: 2 },
    ],
    breakdowns: { family: [ { key: 'materiales', label: 'Materiales' }, { key: 'informacion', label: 'Información' } ], responsible: [] },
  },
  cnc: {
    coverage: metric('cnc_coverage', 83.3, 15, 18),
    pareto: [
      { code: 'MAT', label: 'Materiales', count: 6, cumulativePercent: 33.3 },
      { code: 'PRE', label: 'Prerrequisitos', count: 5, cumulativePercent: 61.1 },
      { code: 'MO', label: 'Mano de obra', count: 3, cumulativePercent: 77.8 },
      { code: 'INF', label: 'Información', count: 2, cumulativePercent: 88.9 },
      { code: 'UNASSIGNED', label: 'No asignado', count: 2, cumulativePercent: 100 },
    ],
    actions: { overdue: 2, byStatus: [ { status: 'open', count: 4 }, { status: 'in_progress', count: 3 }, { status: 'implemented', count: 2 }, { status: 'verified', count: 5 } ] },
    analysisLeadTimeHours: { median: 18.5, p85: 37 },
  },
  quality: [
    { code: 'FAILURE_WITHOUT_CNC', severity: 'warning', count: 3 },
    { code: 'RESTRICTION_WITHOUT_REQUIRED_DATE', severity: 'warning', count: 4 },
    { code: 'DEFAULTED_PROJECT_TIMEZONE', severity: 'info', count: 1 },
  ],
}
